const hyvorContainers = document.querySelectorAll("hyvor-talk-comments");

if (hyvorContainers) {
  hyvorContainers.forEach((container) => {
    const position = container.dataset["position"];
    const root = container.shadowRoot.querySelector("#root");
    if (!root) return;

    injectCustomStyles(root, position);

    if (position === "top") {
      setupReactions(container);
    }
  });
}

function injectCustomStyles(root, position) {
  const styleElement = document.createElement("style");
  styleElement.textContent = `
    .main-box-header, .main-box-footer { display: none !important; }
    .main-box { margin-bottom: 0 !important; }
    .no-comments { padding-bottom: 20px !important; }
    .reactions-title { display: none; }
  `;
  if (position === "top") {
    styleElement.textContent += `
      .main-box { display: none; }
      .reactions-wrap { margin-bottom: 0 !important; }
    `;
  } else if (position === "bottom") {
    styleElement.textContent += `
      .reactions-wrap { display: none; }
    `;
  }
  root.appendChild(styleElement);
}

function setupReactions(container) {
  let selectedReaction = undefined;

  const observer = new MutationObserver(async (mutations) => {
    if (!isLoaderRemoved(mutations)) return;

    const { pageId, websiteId } = getPageAndWebsiteId(container);
    const hyvorPageId = await fetchHyvorPageId(websiteId, pageId);
    const localStorageKey = `${pageId}-reaction`;
    const shadowRoot = container.shadowRoot;
    const reactionButtons = shadowRoot.querySelectorAll(".reaction");

    selectedReaction = restorePreviousReaction(
      reactionButtons,
      localStorageKey
    );

    const clonedButtons = cloneAndReplaceButtons(reactionButtons);

    clonedButtons.forEach((button) => {
      button.addEventListener("click", () => {
        handleReactionClick({
          clickedButton: button,
          allButtons: clonedButtons,
          localStorageKey,
          pageId: hyvorPageId,
          websiteId,
          selectedReactionRef: () => selectedReaction,
          setSelectedReaction: (val) => {
            selectedReaction = val;
          },
        });
      });
    });
  });

  observer.observe(container.shadowRoot, { childList: true, subtree: true });
}

function isLoaderRemoved(mutations) {
  const firstRemovedNode = mutations[0].removedNodes[0];
  return firstRemovedNode?.className === "loader-wrap";
}

function getPageAndWebsiteId(container) {
  return {
    pageId: container.getAttribute("page-id"),
    websiteId: container.getAttribute("website-id"),
  };
}

async function fetchHyvorPageId(websiteId, internalPageId) {
  const response = await fetch(
    `https://talk.hyvor.com/api/data/v1/pages?website_id=${websiteId}&filter=identifier='${internalPageId}'`
  );
  const data = await response.json();
  return data[0].id;
}

function restorePreviousReaction(reactionButtons, localStorageKey) {
  const savedReaction = localStorage.getItem(localStorageKey);
  if (savedReaction) {
    reactionButtons.forEach((button) => {
      if (button.ariaLabel === savedReaction) {
        button.classList.add("reacted");
      }
    });
    return savedReaction;
  }
  return undefined;
}

function cloneAndReplaceButtons(buttons) {
  return Array.from(buttons).map((button) => {
    const clone = button.cloneNode(true);
    button.parentNode.replaceChild(clone, button);
    return clone;
  });
}

function handleReactionClick({
  clickedButton,
  allButtons,
  localStorageKey,
  pageId,
  websiteId,
  selectedReactionRef,
  setSelectedReaction,
}) {
  const reactionType = clickedButton.ariaLabel;
  const currentCount = parseInt(clickedButton.textContent, 10);

  // Send reaction to API
  fetch(
    `https://talk.hyvor.com/api/embed/v3/${websiteId}/page/${pageId}/react`,
    {
      method: "POST",
      body: JSON.stringify({ type: reactionType }),
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    }
  );

  const selectedReaction = selectedReactionRef();

  if (selectedReaction === reactionType) {
    // Un-react
    clickedButton.classList.remove("reacted");
    updateReactionCount(clickedButton, currentCount - 1);
    setSelectedReaction(undefined);
    localStorage.removeItem(localStorageKey);
  } else {
    // Remove previous reaction
    allButtons.forEach((button) => {
      if (button.ariaLabel === selectedReaction) {
        button.classList.remove("reacted");
        updateReactionCount(button, parseInt(button.textContent, 10) - 1);
      }
    });
    // Add new reaction
    updateReactionCount(clickedButton, currentCount + 1);
    clickedButton.classList.add("reacted");
    setSelectedReaction(reactionType);
    localStorage.setItem(localStorageKey, reactionType);
  }
}

function updateReactionCount(button, newCount) {
  const countElement = button.querySelector(".reaction-number")?.children[0];
  if (countElement) {
    countElement.textContent = newCount < 0 ? "0" : newCount.toString();
  }
}
